<template>
    <v-container>  
      <!-- Diálogo -->
      <v-dialog v-model="show" max-width="800px" scrollable>
        <v-card>
          <v-card-title>
            <span class="text-h6">Profile Options</span>
            <v-spacer></v-spacer>
            <v-btn icon dark @click="Close()" >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          </v-card-title>
  
          <!-- Tabs -->
          <v-tabs v-model="tab" background-color="primary" dark>
            <v-tab key="1">My Accounts</v-tab>
            <v-tab key="2">My Characters</v-tab>
            <!-- <v-tab key="3">My Network</v-tab> -->
          </v-tabs>
  
          <!-- Contenido de cada tab -->
          <v-container fluid>
            <v-tabs-items v-model="tab">
              <v-tab-item key=1>
                  <v-row dense>
                      <v-col cols="12">
                      <h1>Administrar Cuenta</h1>
                      <v-form ref="accountForm" v-model="valid">
                          <!-- Cambiar Nombre de Cuenta -->
                          <v-text-field
                          v-model="userid"
                          label="Nombre de la Cuenta"
                          :rules="[rules.required, rules.minLength(3)]"
                          required
                          readonly
                          dense
                          disabled
                          ></v-text-field>
                          <!-- Cambiar Email -->
                          <v-text-field
                          v-model="email"
                          label="Correo Electrónico"
                          type="email"
                          :rules="[rules.required, rules.email]"
                          required
                          ></v-text-field>
                          <!-- Cambiar Contraseña -->
                          <v-text-field
                          v-model="password_current"
                          label="Contraseña Actual"
                          type="password"
                          :rules="[rules.required]"
                          required
                          dense
                          ></v-text-field>
                          <v-text-field
                          v-model="password_new"
                          label="Nueva Contraseña"
                          type="password"
                          :rules="[rules.required, rules.minLength(6)]"
                          required
                          dense
                          ></v-text-field>
                          <v-text-field
                          v-model="password_new_repeat"
                          label="Repetir Nueva Contraseña"
                          type="password"
                          :rules="[rules.required, rules.minLength(6), rules.passwordMatch]"
                          required
                          dense
                          ></v-text-field>
                          <!-- Botón para guardar cambios -->
                           
                      </v-form>
                          <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn :disabled="!valid" color="success" @click="updateAccount">
                            Guardar Cambios
                            </v-btn>
                            <v-spacer></v-spacer>
                          </v-card-actions>
                      </v-col>
                    </v-row>
                </v-tab-item>
                <v-tab-item key=2>
                  <v-row>
                    <v-col cols="12">
                      <h1>Character Management</h1>
                      <v-data-table
                        :headers="headers"
                        :items="items"
                        class="elevation-1"
                        dense
                      >
                        <template v-slot:top>
                          <v-toolbar flat>
                            <v-toolbar-title>Characters</v-toolbar-title>
                            <v-spacer></v-spacer>
                          </v-toolbar>
                        </template>
                        <template v-slot:item.class="{ item }">
                          <span class="caption">{{getjobName(item.class)}}</span>
                        </template>
                        <template v-slot:[`item.options`]="{ item }">
                            <v-icon color="green" class="mr-2" @click="ViewCharacter(item)" title="View">mdi-eye</v-icon>
                            <v-icon color="blue" class="mr-2" @click="ResetPosition(item.char_id)" title="Go to Save Point">mdi-account-convert</v-icon>
                            <v-icon color="red" class="mr-2" @click="UnEquip(item.char_id)" title="Undress">mdi-account-outline</v-icon>
                        </template>
                      </v-data-table>
                    </v-col>
                  </v-row>
              </v-tab-item>
    
              <v-tab-item key=3>
                <v-card-text>
                  <!-- Aquí va el contenido de My Network -->
                  <p>This is the My Network tab.</p>
                </v-card-text>
              </v-tab-item>
            </v-tabs-items>
          </v-container>
        </v-card>
      </v-dialog>
    </v-container>
  </template>
  
  <script>
  import axios from 'axios'; 
  import Vue from 'vue'
  export default {
    props:[
      'id',
      'show',
      'account_id',
      'group_id'
    ],
    data() {
      return {
        headers: [
          { text: "Slot", value: "char_num" },
          { text: "Char Name", value: "name" },
          { text: "Job Name", value: "class" },
          { text: "Base Level", value: "base_level" },
          { text: "Job Level", value: "job_level" },
          { text: "Options", value: "options", sortable: false },
        ],
        RegistroActual: {},
        items: [],
        tab: 0,
        valid: false,
        registroActual: {},
        account: {
          name: '',
          password: '',
          email: ''
        },
        rules: {
          required: value => !!value || 'Este campo es requerido.',
          minLength: min => value => value.length >= min || `Mínimo ${min} caracteres.`,
          email: value => {
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            return pattern.test(value) || 'Correo electrónico inválido.'
          },
          passwordMatch: value => value === this.password_new || 'Las contraseñas no coinciden.'
        },
        userid: '',
        email: '',
        password_current: '',
        password_new: '',
        password_new_repeat: '',
      }
    },
    methods: {
      Close(){
        this.$emit('close');
      },
      ViewCharacter(item){

      },
      UnEquip(char_id){
        axios.put(this.URL('/chars_undress/'+char_id))
        .then(response => {
          Vue.swal.fire({ icon: "success", text: "Account details have been updated." });
        })
        .catch(this.MSGBOX);
      },
      ResetPosition(char_id){
        axios.put(this.URL('/chars_position/'+char_id))
        .then(response => {
          Vue.swal.fire({ icon: "success", text: "Account details have been updated." });
        })
        .catch(this.MSGBOX);
      },
      updateAccount(){
        if (this.$refs.accountForm.validate()) {
          this.registroActual.user_pass = this.password_new;
          this.registroActual.email = this.email;
          axios.put(this.URL('/login/'+this.account_id),this.registroActual)
          .then(response => {
            this.user_pass =  response.data.user_pass;
            this.password_current =      response.data.email;
            this.password_new = '';
            this.password_new_repeat = this.password_new;
            Vue.swal.fire({ icon: "success", text: "Account details have been updated." });
            this.$refs.accountForm.resetValidation();
          })
          .catch(this.MSGBOX);
        }
      },
      getAccount(){
        axios.get(this.URL('/login/'+this.account_id))
        .then(response => {
            let data = response.data;
            this.userid = data.userid;
            this.email = data.email;
            this.password_current = data.user_pass;
        })
        .catch(this.MSGBOX);
      },
      getRegistros(){
        axios.get(this.URL('/char/'+this.account_id))
        .then(response => {
            this.items = response.data;
        })
        .catch(this.MSGBOX);
      },

    },
  watch: {
    show : function (){
      if (this.show) {
        this.$nextTick(() => {
          this.getAccount();
        });
      }
    },
    tab : function (value){
      switch (value) {
        case 0:
          this.getAccount();
          break;
        case 1:
          this.getRegistros();
          break;
        default:
          break;
      }
    }
  }
}
</script>